import { ChangeDetectorRef, inject, signal } from '@angular/core';
import { HttpErrorService, StationsCheckoutService, StationsService } from '../../../services';
import { PublicRoutes } from '../../../enums';
import { Router } from '@angular/router';
import { ProcessOrderResponse } from '../../../models';
import { ConfirmationService } from 'primeng/api';

const STATION_IN_USE_ERROR_CODE = '59';
const STATION_TOO_MANY_GUESTS_ERROR_CODE = '57';

/** when extending this class be sure to implement ngOnInit */
export class NgxAimStationOverview {
  // ngOnInit() {
  //   this.init();
  // }

  stationsService = inject(StationsService);
  checkoutService = inject(StationsCheckoutService);
  httpErrorService = inject(HttpErrorService);
  router = inject(Router);
  confirmationService = inject(ConfirmationService);
  changeRef = inject(ChangeDetectorRef);

  isLoading = signal(false);
  routes = PublicRoutes;
  selectedGroup = this.stationsService.getSelectedGroup();
  selectedStation = this.stationsService.getSelectedStation();
  selectedTime = this.stationsService.getSelectedTime();
  selectedDate = this.stationsService.getSelectedDate();
  durationString = '';
  Notes = this.stationsService.Notes;
  allowedGuestMessage = this.stationsService.allowedGuetsMessage;
  amountOfGuestsOptions: number[] = [];
  selectedAmountofGuests = 0;
  error = '';
  hasGuest = false;
  showError = false;

  init() {
    if (this.selectedGroup && this.selectedStation) {
      this.initAllowedGuests();
      this.initDuration();
    } else {
      this.router.navigate([this.routes.STATIONS, this.routes.GROUPS]);
    }
  }

  onCompleteClick() {
    if (this.hasGuest && !this.selectedAmountofGuests) {
      this.error = 'Please select the amount of guests';
      this.showError = true;
      return;
    }

    this.isLoading.set(true);
    this.stationsService.Notes = this.Notes;
    this.stationsService.setSelectedAmountOfGuests(this.selectedAmountofGuests);
    this.checkoutService.checkout().subscribe({
      next: (res) => this.onReserveRequestSuccess(res),
      error: (err) => this.onReserveFailure(err),
    });
  }

  initAllowedGuests() {
    this.allowedGuestMessage = `You are allowed ${this.selectedStation!.MaxUsers || 0} additional guest${this.selectedStation!.MaxUsers > 1 ? 's' : ''} at this station.`;
    this.stationsService.allowedGuetsMessage = this.allowedGuestMessage;
    this.amountOfGuestsOptions = [...Array(this.selectedStation!.MaxUsers).keys()].map(key => key + 1);
  }

  initDuration() {
    const durationMinutes = this.stationsService.getSelectedDuration()!;
    if (durationMinutes > 90) {
      this.durationString = `${durationMinutes / 60} Hours`;
    } else {
      this.durationString = `${durationMinutes} Minutes`;
    }
  }

  onReserveRequestSuccess(res: ProcessOrderResponse) {
    this.isLoading.set(false);
    if (this.hasGuest) {
      this.stationsService.allowedGuetsMessage = this.allowedGuestMessage
    } else {
      this.stationsService.allowedGuetsMessage = '';
    }

    if (res.Status?.ErrorCode) {
      switch (res.Status.ErrorCode) {
        case STATION_IN_USE_ERROR_CODE: {
          this.error = 'Station is already reserved. Please choose a different date or time';
          this.showError = true;
          this.changeRef.detectChanges();
          break;
        }
        case STATION_TOO_MANY_GUESTS_ERROR_CODE: {
          this.error = 'Maximum amount of guests exceeded';
          this.showError = true;
          this.changeRef.detectChanges();
          break;
        }
      }
    } else {
      this.router.navigateByUrl(`${PublicRoutes.STATIONS}/${PublicRoutes.GROUPS}/:groupId/${PublicRoutes.STATION_COMPLETE}`);
    }
  }

  onReserveFailure(err: any) {
    this.isLoading.set(false);
    this.httpErrorService.onHttpError(err, 'Could not reserve station. Please try again');
  }
}